import style from './style.scss';

// TODO: we might wanna change this and have something nicer
const AppLoader = () => <div className={style.appLoader}>Loading...</div>;

export default AppLoader;
